let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("g7yss")).then(() => parcelRequire('4ECv0'));